module.exports = __webpack_public_path__ + "static/media/product_category_32.25325697.png";